import React from 'react'
import { CheckIcon } from '@heroicons/react/24/solid'

const steps = [
  { label: 'Why Sokooni' },
  { label: 'Account Verification' },
  { label: 'Account Registration' },
]

const Stepper = ({ currentStep = 0 }) => {
  const renderStep = (step, index, isLastStep) => (
    <>
      <div key={step.label} className="flex flex-col items-center">
        <div
          className={`w-6 h-6 rounded-full flex items-center justify-center transition-colors relative ${
            index < currentStep
              ? 'bg-success-500'
              : index === currentStep
              ? 'bg-secondary-700'
              : 'bg-neutral-100 border border-secondary-700'
          }`}
        >
          {index < currentStep && <CheckIcon className="w-4 h-4 text-white" />}
        </div>

        <span
          className={`absolute top-8 text-center text-sm capitalize mt-2 font-inter ${
            index === currentStep
              ? 'text-secondary-700 font-semibold'
              : 'text-foreground font-normal'
          }`}
        >
          {step.label}
        </span>
      </div>
      {!isLastStep && <div className=" flex-1 h-1 bg-neutral-200 " />}
    </>
  )

  return (
    <div className="relative flex items-center justify-between  mb-20 mx-4">
      {steps.map((step, index) => renderStep(step, index, index === steps.length - 1))}
    </div>
  )
}

export default Stepper
